<template>
  <v-hover>
    <v-card
      slot-scope="{ hover }"
      class="flexcard"
      height="100%"
      ripple
      :class="{ 'blue-grey lighten-5 elevation-7': hover }"
    >
      <v-icon v-if="!currentUserCanEdit" class="flexcard-icon">not_interested</v-icon>
      <v-responsive @click="openNews">
        <cloudinary-image
          v-if="image && image[0]"
          :id="image[0].public_id"
          :version="image[0].version"
          :transformation="`w_600,h_300,c_fill,q_auto,f_jpg,g_faces:center${
            !currentUserCanEdit ? ',e_grayscale,o_50' : ''
          }`"
        />
        <v-img :aspect-ratio="2" v-else class="grey lighten-3">
          <v-layout fill-height align-center justify-center>
            <v-flex class="text-xs-center">
              <v-icon large>insert_photo</v-icon>
            </v-flex>
          </v-layout>
        </v-img>
      </v-responsive>
      <v-card-title primary-title class="grow pt-3" @click="openNews">
        <div class="tronchetto">
          <v-tooltip top>
            <span
              class="subheading font-weight-black mb-0 title-size"
              :class="{ 'grey--text': !currentUserCanEdit }"
              slot="activator"
            >
              {{ news.title[news.default_lang] }}
            </span>
            {{ news.title[news.default_lang] }}
          </v-tooltip>
          <div class="grey--text sub-overflow" v-if="subtitle.length > 0">{{ subtitle }}</div>
          <div class="grey--text" v-else><br /></div>
          <div class="grey--text pt-4 font-italic">
            <div>
              <v-icon aria-hidden="true" class="label-icon">person</v-icon
              ><span>{{ news.cuser }}</span>
            </div>
            <div>
              <v-icon aria-hidden="true" class="label-icon">access_time</v-icon
              ><span>{{ news.publication_date }} {{ news.publication_hour }}</span>
            </div>
            <div>
              <v-icon aria-hidden="true" class="label-icon">check</v-icon
              ><span>{{ newsStatus == 'bozza'? $t('news.bozza') : ( newsStatus == 'pubblicata'? $t('news.pubblicata') : $t('news.scaduta')) }}</span>
            </div>
            <div>
              <v-icon aria-hidden="true" class="label-icon">account_tree</v-icon
              ><span class="text-underline"
                >{{ news.federation.length }}
                {{ news.federation.length > 1 ? $t('news.siti') : $t('news.sito') }}</span
              >
            </div>
          </div>
        </div>
      </v-card-title>

      <v-card-actions :class="{'box-height': !currentUserCanEdit}">
        <div class="align-buttons-horizontally no-pointer" v-if="currentUserCanEdit">
          <div>
            <v-btn
              x-small
              color="primary"
              @click.stop="duplicateNews"
              >{{ $t('news.duplica') }}</v-btn
            >
          </div>
          <div>
            <v-btn flat  :class="isDrin? 'bold-text secondary--text ml-2' : 'indigo--text text--darken-2 bold-text ml-2'" @click.stop="confirm = true"
              >{{ $t('news.elimina') }}</v-btn
            >
          </div>
        </div>
      </v-card-actions>
      <!-- conferma elimina -->
      <v-dialog v-model="confirm" persistent max-width="320">
        <v-card>
          <v-card-title class="headline">
            <span>{{ $t('news.attenzione') }}</span>
          </v-card-title>
          <v-card-text>
            <span v-if="true">{{ $t('news.msg1') }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="confirm = false">
              <span>Annulla</span>
            </v-btn>
            <v-btn color="error" flat @click.native="deleteNews">{{ $t('news.elimina') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-hover>
</template>

<script>
import cloudinaryImage from '@/components/common/CloudinaryImage';
import { $formatDate } from '@/mixins/dates';
import { $userCanEditNews } from '@/mixins/news';
import { $EventBus } from '@/eventBus';
import _ from 'lodash';
export default {
  data() {
    return {
      confirm: null, // conferma se eliminare la news o no
      isDrin: null,
    };
  },
  props: {
    news: {
      type: Object,
      required: true,
    },
  },
  components: {
    cloudinaryImage,
  },
  mixins: [$formatDate, $userCanEditNews],
  methods: {
    openNews() {
      if (!this.currentUserCanEdit) {
        $EventBus.$emit('message', { type: 'warning', text: this.CantEditMessage });
      } else {
        this.$router.push({
          name: 'newsItem',
          params: { id: this.news._id },
          query: { ...this.$route.query },
        });
      }
    },
    duplicateNews() {
      this.$router.push({
        name: 'newsItem',
        params: { id: this.news._id },
        query: { ...this.$route.query, duplicate: true },
      });
    },
    deleteNews() {
      this.confirm = false;
      this.$http
        .delete(`/news/${this.news._id}`)
        .then((response) => {
          $EventBus.$emit('message', { type: 'success', text: this.$t('success.news.deleted') });
          this.showPrompt = false;
          this.$router.push({ name: 'newsList', query: { ...this.$route.query } });
        })
        .catch((err) => {
          console.log(err);
          $EventBus.$emit('message', { type: 'error', text: this.$t('error.news.delete') });
        });
    },
  },
  mounted() {
    if(this.$store.state.user.userTheme == 'drin') {
      this.isDrin = true;
    }
    else {
      this.isDrin = false;
    }
  },
  computed: {
    subtitle() {
      return this.news.body_text[this.news.default_lang];
    },
    image() {
      return this.news.image;
    },
    currentUserCanEdit() {
      return this.$userCanEditNews(this.$user, this.news);
    },
    CantEditMessage() {
      if (this.news.locked) {
        return this.$t('warning.news.edit') + `${this.news.cuser} ` + this.$t('warning.news.block');
      } else {
        return this.$t('error.news.edit');
      }
    },
    newsStatus() {
      let text = null;
      switch (this.news.status) {
        case 1:
          text = 'pubblicata';
          break;
        case 0:
          text = 'bozza';
          break;
        case -1:
          text = 'scaduta';
          break;
      }
      return text;
    },
  },
};
</script>

<style scoped>

.no-pointer {
  cursor: default;
}

.box-height {
  height: inherit;
}
.label-icon {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.3);
  margin-right: 5px;
}

.title-size {
  font-size: 18px;
}

.bold-text {
  font-weight: 800;
}

.align-buttons-horizontally {
  display: flex;
  width: 100%;
}

.flexcard {
  display: flex;
  flex-direction: column;
  position: relative;
}
.flexcard:hover {
  cursor: pointer;
}
.flexcard img {
  max-width: 100%;
}
.flexcard-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
  color: rgba(255, 255, 255, 0.7);
}
.tronchetto {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-underline {
  text-decoration: underline;
}

.sub-overflow {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
